import loadable from '@loadable/component';
import classNames from 'classnames';
import LoadingDots from 'components/LoadingDots';
import React, { useEffect, useState } from 'react';

const CSS = require('./Load.module.scss');

function Loading({ pushLoadingDown }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), 200);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  if (show) {
    return (
      <div className={CSS.Container}>
        <LoadingDots
          className={classNames({ [CSS.PushDown]: pushLoadingDown })}
        />
      </div>
    );
  }

  if (pushLoadingDown) {
    return (
      <div className={CSS.Container}>
        <LoadingDots className={CSS.PushDown} />
      </div>
    );
  }

  return null;
}

function Load(
  importCall: () => Promise<any>,
  extraProps: any = {},
  pushLoadingDown = false,
) {
  return loadable(importCall, {
    fallback: <Loading pushLoadingDown={pushLoadingDown} />,
  });
}

export default Load;
